<template>
  <!-- 曲线1 -->
  <div
      id="voltageOne"
      ref="voltageOne"
      class="voltage-one"
      style="width:100%;height:83px"
  ></div>
</template>

<script>
import { chartConfig, d019ChartConfig, voltageData } from "@/config/echarts-data";
import { calcHistoryPower, calcMaxPower, calcPower, calcVoltageFloorInt } from "@/util/utils";
import { mapState } from "vuex";
import userMixin from "@/mixins/userMixin";

const graphic = require("echarts/lib/util/graphic");

export default {
  name: "HistoryCurve",
  mixins: [userMixin],
  props: {
    power: {
      type: Array,
      default: () => []
    },
    maxPower: {
      type: Number,
      default: 10
    },
    resistance: {
      type: Number,
      default: 1.2
    },
    curveColor: {
      type:String,
      default:'#86A1A9'
    },
    curveLineColor: {
      type:Array,
      default:()=> {
        return [
          {offset:1,color:'rgba(0, 60, 255, 1)'},
          {offset:0.75,color:'rgba(108, 158, 255, 0.75)'},
          {offset:0,color:'rgba(255, 255, 255, 0)'}
        ]
      }
    },
    deviceLevel: {
      type:Number,
      default: 0
    }

  },
  data() {
    return {
      curveChart: null
    };
  },
  mounted() {
    this.refreshVoltageCurve()
  },
  methods: {
    onWindowSizeChanged() {
      this.curveChart.resize();
    },
    refreshVoltageCurve() {
      //  //触发浏览器渲染
      let width =  this.$refs.voltageOne.style.width
      this.$nextTick(() => {
        if (this.$refs.voltageOne) {
          this.curveChart = this.$echarts.init(this.$refs.voltageOne);
          window.addEventListener("resize", this.onWindowSizeChanged);
        }
        const power = this.power;
        if (!power) {
          return;
        }

        const voltageData = d019ChartConfig(this.deviceLevel >0 ? '': '',this.deviceLevel,false );
        voltageData.yAxis.min = 0.01;
        voltageData.yAxis.max = this.maxPower;
        voltageData.series[0].data = power
        if (this.deviceLevel <= 0) {

          voltageData.color[0] = this.curveColor;
          voltageData.series[0].label.color = this.curveColor;
          voltageData.series[0].areaStyle.color = graphic.LinearGradient(
              0,
              1,
              0,
              0,
              this.curveLineColor
          );
        }
        this.curveChart.setOption(voltageData, true);
      });
    }
  },
  computed: {
  },
  watch: {
    power(value) {
      this.refreshVoltageCurve()
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowSizeChanged);
    this.curveChart.dispose()
    this.curveChart = null
  }
};
</script>



<style scoped lang="less">

.voltage-one {
}
</style>